import React, { Component } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import cx from 'classnames'
import _ from 'lodash'

import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'

import { TYPES } from '../../constants'
import Minireport from '../../../../../../../../../../components/Minireport'

import './style.scss'
import ContextBurger from '../../../../../../../../../../components/ContextBurger'

export default class HistoryList extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        collapsed: PropTypes.bool,
        customData: PropTypes.object,
        history: PropTypes.array.isRequired,
        identifier: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        noParents: PropTypes.bool,
        toggleOwnershipSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            historyTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            holdingTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
        type: PropTypes.string.isRequired,
    }

    static defaultProps = {
        collapsed: false,
    }

    handleToggleOwnershipSection = () => {
        const { module, block, customData, toggleOwnershipSection, identifier, mainId } = this.props

        const isOpen = _.get(customData, `toggledSections.${identifier}`, false)
        const newCustomData = {
            ...customData,
            toggledSections: {
                ...customData.toggledSections,
                [identifier]: !isOpen,
            },
        }

        toggleOwnershipSection(module, mainId, block, newCustomData)
    }

    render() {
        const {
            history,
            collapsed,
            type,
            noParents,
            translates: { historyTitle, holdingTitle, from, to },
        } = this.props
        const { PARENTS } = TYPES

        return (
            <div className={cx('ownership-history-list', { parents: PARENTS === type })}>
                <div className={'ownership-history-border'}>
                    <div
                        className={cx('ownership-history-navigator', {
                            parents: PARENTS === type,
                            'empty-parents': noParents,
                            collapsed,
                        })}
                    />
                    <div className={'arrow-right'} onClick={this.handleToggleOwnershipSection} />
                </div>
                <div className={'ownership-history-table'}>
                    <div className={'ownership-history-row'}>
                        <div
                            className={cx('collapse-title', { collapsed })}
                            onClick={this.handleToggleOwnershipSection}
                        >
                            {historyTitle}
                        </div>
                        <div>{collapsed && holdingTitle}</div>
                        <div className={'date-field '}>{collapsed && from}</div>
                        <div className={'date-field '}>{collapsed && to}</div>
                    </div>
                    {collapsed &&
                        history.map(({ subject, relation }, key) => {
                            const minireport = <Minireport id={`${subject?.id}`} />

                            return (
                                <Tooltip
                                    key={`ownership-history-row-${key}`}
                                    content={minireport}
                                    id={`tooltip_ownership_history_minireport_${subject?.id}_${key}`}
                                    position={POSITION.TOP}
                                    align={ALIGN.LEFT}
                                    width={'320px'}
                                    showDelay={1000}
                                >
                                    <div className={'ownership-history-row'}>
                                        <div>
                                            <span>{subject?.name}</span>
                                            <div className={'burger-container'}>
                                                <ContextBurger entity={subject} id={subject?.id} />
                                            </div>
                                        </div>
                                        <div>
                                            {_.get(relation, 'percentage', 0) &&
                                                `${parseFloat(_.get(relation, 'percentage', 0)).toFixed(2)}%`}
                                        </div>
                                        <div className={'date-field'}>
                                            {_.get(relation, 'startDate.value', null) &&
                                                moment(_.get(relation, 'startDate.value')).format('D. M. YYYY')}
                                        </div>
                                        <div className={'date-field'}>
                                            {_.get(relation, 'endDate.value', null) &&
                                                moment(_.get(relation, 'endDate.value')).format('D. M. YYYY')}
                                        </div>
                                    </div>
                                </Tooltip>
                            )
                        })}
                </div>
            </div>
        )
    }
}
